import { mapState } from 'vuex'
import BillShared from '@Bill/sections/BillShared'
import ProjectShared from '@Bill/sections/ProjectShared'

export default {
  components: {
    BillShared,
    ProjectShared,
  },
  computed: {
    ...mapState('bill', {
      billShared: state => state.billShared,
      projectShared: state => state.projectShared,
      projectSharedShow: state => state.projectSharedShow,
    }),
  },
}
